import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GeneralModalState } from '../models/loader';

@Injectable({
  providedIn: 'root'
})
export class GeneralModalService {
  private loaderSubject = new Subject<GeneralModalState>();

  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  show(errMessage: string) {
    this.loaderSubject.next(<GeneralModalState>{ title: errMessage, content: errMessage });
  }

  hide() {
    this.loaderSubject.next(<GeneralModalState>{ show: false });
  }
}
